export const api =
    process.env.NODE_ENV === 'development'
        ? require('./api.mock').default
        : require('./api').default;
